import { ClientManagementButtonDelete } from './ButtonDelete';

export const ButtonDelete = ClientManagementButtonDelete;

